module.exports = __webpack_public_path__ + "static/media/youtube.4256c86b.svg";